import { createSelector } from "reselect";

const microFrontendIdSelector = (state) => state?.microFrontend;

const selectMicroFrontendId = createSelector(
  microFrontendIdSelector,
  (microFrontend) => microFrontend?.id
);

export { microFrontendIdSelector, selectMicroFrontendId };
